exports = module.exports = require("../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".epic-spinners-simple-demo[data-v-77cab62d]{-ms-flex-wrap:wrap;flex-wrap:wrap}.epic-spinners-simple-demo[data-v-77cab62d],.epic-spinners-simple-demo>div[data-v-77cab62d]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.epic-spinners-simple-demo>div[data-v-77cab62d]{float:left;margin:20px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", ""]);

// exports
